import {
	createApp
} from 'vue'
import App from './App.vue'
import router from './router'

import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css'

import 'animate.css'
import WOW from 'wow.js'
import './assets/iconfont/iconfont.css'
import './assets/css/common.scss'










new WOW({
	animateClass: 'animate__animated', // 关键：与 animate.css v4+ 适配（必须带 animate__ 前缀）
	offset: 100, // 元素进入视口多少像素后触发动画（可选）
	mobile: true, // 移动设备是否执行动画（默认 true，可选）
	live: true // 是否监听动态添加的元素（默认 true，可选）
}).init()


// // import 'swiper/dist/css/swiper.min.css'
// // import 'swiper/dist/js/swiper.min'
// import 'swiper/css/swiper.min.css'


const app = createApp(App);

createApp(App)
	.use(router).use(ElementPlus)
	.mount('#app')